import IconButton from '@mui/material/IconButton';
import { useState  } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import Popover from '@mui/material/Popover';
import { Tooltip } from '@mui/material';
import SearchBox from '../SearchBox';


export default function DropdownSearch({ executeSearchFunction, placeholderText, tooltip, value }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [show, setShow] = useState(false);


  const handleClick = (event) => {
    setShow(false);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleOnSearch = (text) => {
	  executeSearchFunction(text);
	  handleClose();
  }

  const open = Boolean(anchorEl);
  const id = open ? 'dropdown-search' : undefined;

  return (
	<Tooltip title={tooltip} 
	    open={show} 
        disableHoverListener
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}> 
    <div>
      <IconButton
        onClick={handleClick}
        className='w-40 h-40'
        size="large"
      >
        <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div style={{maxWidth: '300px', padding: '10px', paddingBottom: '0px'}}>
        	<SearchBox executeSearchFunction={handleOnSearch} placeholderText={placeholderText} value={value} />
        </div>
      </Popover>
    </div>
    </Tooltip>
  );
}